import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-docflo-solar-documentation-and-contracting.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Solar Contracts";

const Docflo = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={clsx(styles.timelineFigure)}>
          <div className="mx-auto w-1/2 md:w-[110%] md:ml-[15%]">
            <Image
              src={FigureImage}
              alt="Enerflo Docflo is our in-house docsiging solution that creates signing packets in seconds which include State-required docs for compliance, installer contracts and interconnection agreements."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Get the right customer docs, every time. Enerflo’s proprietary Docflo engine was built specifically for the solar industry, putting it head and shoulders above other docsigning solutions. Close deals faster with signing packets built in 3 seconds, including interconnection agreements, rebate forms, HOA docs and more. Reduce mistakes and change orders."
          offsetFigure
          link="/features/docflo"
          icon={
            <Image
              src="/images/icons/docflo.svg"
              alt="Icon - Enerflo Docflo"
              layout="responsive"
              height={61}
              width={68}
              quality={100}
              className="crispImage"
            />
          }
        />
      </div>
    </HeroSection>
  </div>
);

export default Docflo;
